import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      meta: {
        title: '精选主题'
      }
    }
  ]
})

// 使用afterEach钩子函数，保证路由跳转成功之后修改title
router.afterEach(route => {
  let documentTitle = ''

  route.matched.forEach(path => {
    if (path.meta.title) {
      documentTitle = path.meta.title
    }
  })

  if (documentTitle) {
    document.title = documentTitle
    // 直接修改title，ios设备不能自动刷新，需要调用客户端的方法进行更新
    if (window.goods && window.goods.updateTitle) {
      window.goods.updateTitle({ title: documentTitle })
    }
  }
})

export default router
